if (!window.ddComparisonReviewsBound) {
  window.ddComparisonReviewsBound = true;
  let loading = false;
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-dd-comparison-reviews]');
    if (!trigger || loading) return;
    event.preventDefault();
    loading = true;
    trigger.setAttribute('aria-busy', 'true');
    const url = new URL(trigger.dataset.ddComparisonReviews, location.origin);
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product reviews unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const shell = page.querySelector('dd-pdp-lightbox[data-product-id]');
      if (!shell?.querySelector('#stamped-main-widget')) throw new Error('Product reviews unavailable');
      // The product HTML includes a static summary, not initialized review entries.
      // Start with an empty widget so the controller requests the full product reviews.
      shell.querySelector('#stamped-main-widget').replaceChildren();
      await customElements.whenDefined('dd-pdp-lightbox');
      document.querySelectorAll('[data-dd-comparison-review-shell]').forEach((old) => old.remove());
      shell.querySelectorAll('script, .dd-pdp-lightbox__templates').forEach((node) => node.remove());
      shell.setAttribute('data-dd-comparison-review-shell', '');
      const imported = document.importNode(shell, true);
      document.body.appendChild(imported);
      imported.openReviews(trigger);
    } catch (error) {
      // Keep the fallback product-specific as well.
      url.hash = 'stamped-main-widget';
      location.assign(url.href);
    } finally {
      loading = false;
      trigger.removeAttribute('aria-busy');
    }
  });
}
